import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LinkButton, useAnalyticsAttributes, useAnalytics } from '../../../../../components';
import { SelectText, TeamsContainer } from './SelectTextMessage.styles';
export function SelectTeamMessage({ text, organizations }) {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    if (organizations.length > 0) {
        return (_jsxs(_Fragment, { children: [_jsx(SelectText, { document: text }, void 0), _jsx(TeamsContainer, { children: organizations.map(({ id, displayName, url }) => (_jsx(LinkButton, Object.assign({ url: `${url}/account`, appearance: "Primary", onClick: () => {
                            sendTrackEvent('clickedAddSlackToWorkspace', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: 'button' }));
                        } }, { children: displayName }), id))) }, void 0)] }, void 0));
    }
    else {
        return null;
    }
}
//# sourceMappingURL=SelectTeamMessage.js.map